import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { setMenuError, setMenuInfo } from '../../reducers/menuReducers.jsx';
import { setUserInfo } from '../../reducers/userReducers.jsx';
import { setLangCodeInfo } from '../../reducers/langCodeReducers.jsx';
import { initializeI18n } from '../../i18n.jsx';
import { AppSettings } from '../../config/app-settings.js';
import API from '../../api/api.jsx';

const Otp = () => {
    const context   = React.useContext(AppSettings);
    const navigate  = useNavigate();
    const dispatch  = useDispatch();
    const location  = useLocation();
    const user      = location.state.randomOtp ? location.state.response : location.state;
    const otp_state = location.state.randomOtp ? location.state.randomOtp : '';

    const [otp, setOtp]                     = useState('');
    const [time, setTime]                   = useState({ minutes: 3, seconds: 0 });
    const [randomOtp, setRandomOtp]         = useState(otp_state);
    const [timerInterval, setTimerInterval] = useState(null);

    useEffect(() => {
        setupAppSettings(true);

        startTimer();

        return () => {
            setupAppSettings(false);
            clearInterval(timerInterval);
        };
    }, []);

    let isHandlingClick = false; // 클릭 처리 여부를 나타내는 변수
    // OTP ZALO로 발급 받는 부분
    const generate_OTP = async () => {
        if (isHandlingClick) return; // 클릭 처리 중이면 중복 클릭 방지
		isHandlingClick = true; // 클릭 처리 시작

        try {
            await API.generateOTP(user)

        } catch (error) {
            console.error('Error Generate OTP : ', error);
            const message = error.response.data.result.content.message;
            alert(message);
            return;
        } finally {
			isHandlingClick = false; // 클릭 처리 종료
		};
    };

    // 기초 앱 세팅 (기존 테마에 존재하던 코드라 남겨놓음)
    const setupAppSettings = (isNone) => {
        context.handleSetAppSidebarNone(isNone);
        context.handleSetAppHeaderNone(isNone);
        context.handleSetAppFooterNone(isNone);
        context.handleSetAppThemeNone(isNone);
        context.handleSetAppContentClass(isNone ? 'p-0' : '');
    };

    // 랜덤 OTP 생성 (추후 generate_OTP() 활성화시 generateRandomOtp함수는 사용되지 않음)
    const generateRandomOtp = () => {
        return Math.floor(100000 + Math.random() * 900000);
    };
    

    // 타이머 시작 함수
    const startTimer = () => {
        const intervalId = setInterval(() => {
            setTime((prevTime) => {
                const { minutes, seconds } = prevTime;

                if (minutes === 0 && seconds === 0) {
                    clearInterval(intervalId);
                    return prevTime;
                }

                const newSeconds = seconds === 0 ? 59 : seconds - 1;
                const newMinutes = seconds === 0 ? minutes - 1 : minutes;

                return { minutes: newMinutes, seconds: newSeconds };
            });
        }, 1000);

        setTimerInterval(intervalId);
    };

    // 타이머 초기화 함수
    const resetTimer = () => {
        setTime({ minutes: 3, seconds: 0 });
        clearInterval(timerInterval);
        startTimer();
    };

    // resendOTP 버튼을 눌렀을 때 초기화 함수 호출
    const resendOTP = () => {
        setOtp('');

        // 개발단계에서는 alert 형태로 확인
        if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'stage') {
            const generatedOtp = generateRandomOtp();
            alert(`Your OTP: ${generatedOtp}`);
            setRandomOtp(String(generatedOtp));
        } else {
            // OTP 호출 함수 (해당 부분 살리면 ZALO OTP 성공)
            generate_OTP();
        }

        resetTimer();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // 개발단계에서 alert 형태로 로그인
        if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'stage') {
            if (otp === randomOtp) {
                // API 호출 부분
                try {
                    await API.fetchMenu(user)
                    .then(response => {
                        dispatch(setUserInfo(user));
                        dispatch(setLangCodeInfo(user.lang_code));
                        dispatch(setMenuInfo(response));

                        initializeI18n();

                        navigate('/loan/loan_001');
                    })
                    .catch(error => {
                        dispatch(setMenuError(error))
                    });

                } catch (error) {
                    console.error('Menu Error', error);
                    dispatch(setMenuError(error));
                }
            } else {
                alert('Incorrect OTP. Please try again.');
                setOtp('');
                return;
            }
        } else {
            if (otp) {
                if (isHandlingClick) return; // 클릭 처리 중이면 중복 클릭 방지

		        isHandlingClick = true; // 클릭 처리 시작

                try {
                    await API.verifyOTP({ user, otp });

                    try {
                        await API.fetchMenu(user)
                        .then(response => {
                            dispatch(setUserInfo(user));
                            dispatch(setLangCodeInfo(user.lang_code));
                            dispatch(setMenuInfo(response));

                            initializeI18n();

                            navigate('/loan/loan_001');
                        })
                        .catch(error => {
                            dispatch(setMenuError(error))
                        });
                    } catch (error) {
                        console.error('Menu Error', error);
                        dispatch(setMenuError(error));
                    } finally {
                        isHandlingClick = false; // 클릭 처리 종료
                    }

                } catch (error) {
                    console.error("Verify OTP : ", error);
                    alert('Incorrect OTP. Please try again.');
                    setOtp('');
                    return;
                }
            }
        }
    };

    return (
        <React.Fragment>
            <div className="login login-v2 fw-bold">
                <div className="login-cover">
                    {/* <div className="login-cover-img" style={{ backgroundImage: 'url(' + this.state.activeBg + ')'}}></div> */}
                    <div className="login-cover-img"></div>
                    <div className="login-cover-bg"></div>
                </div>
        
                <div className="login-container">
                    <div className="login-header">
                        <div className="brand">
                            <div className="d-flex align-items-center">
                                <span className="logo"></span> <b>DIDO OTP</b>
                            </div>

                            <small>
                                <div className="countdown-text">
                                    <p>Time Remaining: {`${time.minutes}:${time.seconds < 10 ? `0${time.seconds}` : time.seconds}`}</p>

                                    <button
                                        disabled={time.seconds > 0 || time.minutes > 0}
                                        style={{
                                            color: time.seconds > 0 || time.minutes > 0 ? "#DFE3E8" : "#FF5630",
                                        }}
                                        onClick={resendOTP}
                                    >
                                        Resend OTP
                                    </button>
                                </div>
                            </small>
                        </div>

                        <div className="icon">
                            <i className="fa fa-unlock"></i>
                        </div>
                    </div>
                    
                    <div className="login-content">
                    <OtpInput
                        value={otp}
                        onChange={(otp) => setOtp(otp)}
                        numInputs={6}
                        renderSeparator={<span style={{ width: "10px" }}></span>}
                        shouldAutoFocus={true}
                        renderInput={(inputProps, index) => (
                            <input
                            {...inputProps}
                                type="tel" // 숫자 및 웹에서 숫자 증가 버튼을 사용하지 않기 위해
                                pattern="[0-9]*" 
                                inputMode="numeric"
                                style={{
                                    ...inputProps.style,
                                    width: "50px", // Set the width to 40px
                                    border: inputProps.isFocused ? "1px solid #CFD3DB" : "1px solid transparent",
                                    borderRadius: "8px",
                                    height: "54px",
                                    fontSize: "14px",
                                    color: "#000",
                                    fontWeight: "400",
                                    caretColor: "black",
                                    marginBottom: "20px",
                                }}
                                key={index}
                            />
                        )}
                    />
                    <div className="text-gray-500 d-flex justify-content-center">
                        {/* <Link to="/loan/loan_001"> */}
                            <Button className="btn btn-success" onClick={handleSubmit}>SUBMIT</Button>
                        {/* </Link> */}
                    </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
};

export default Otp;
